import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/landing/Header';
import HeroSection from '../components/landing/HeroSection';
import FormsSection from '../components/landing/FormsSection';
import HowItWorksSection from '../components/landing/HowItWorksSection';
import WhoWeHelpSection from '../components/landing/WhoWeHelpSection';
import MarketsSection from '../components/landing/MarketsSection';
import TrustSection from '../components/landing/TrustSection';
import Footer from '../components/landing/Footer';
import SEOHead from '../components/SEOHead';
import { Toaster } from '../components/ui/sonner';
import { cities } from '../data/cities';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'DreamHousesUSA',
  description:
    'Real estate investment and wholesaling company. We buy houses for cash in any condition nationwide — featured markets include Detroit, Memphis, Cleveland, Atlanta, Indianapolis, Baltimore, Philadelphia, and more.',
  url: 'https://www.dreamhousesusa.com',
  email: 'info@dreamhousesusa.com',
  areaServed: cities.map((c) => ({
    '@type': 'City',
    name: c.name,
    containedInPlace: { '@type': 'State', name: c.state },
  })),
  slogan: 'Sell Your House Fast or Access Off-Market Wholesale Deals Nationwide',
  knowsAbout: [
    'Real Estate Wholesaling',
    'Property Investment',
    'Cash Home Buying',
    'Off-Market Properties',
    'Distressed Properties',
    'Assignment of Contract',
    'Double Closing',
    'Detroit Wholesale Real Estate',
    'Michigan Cash Home Buyers',
    'Memphis Turnkey Rentals',
    'BRRRR Cleveland',
  ],
};

const LandingPage = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (!hash) return;
    const id = hash.replace('#', '');
    const el = document.getElementById(id);
    if (el) {
      const timer = setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 50);
      return () => clearTimeout(timer);
    }
  }, [location.hash]);

  return (
    <div className="min-h-screen">
      <Toaster position="top-right" richColors />
      <SEOHead
        title="DreamHousesUSA | We Buy Houses Detroit, Phoenix, Los Angeles, Memphis & More | Cash Home Buyers & Wholesale Deals"
        description="We buy houses for cash in Detroit, Phoenix, Los Angeles, Sacramento, Memphis, Cleveland, Atlanta & more. Sellers: fast cash offers, any condition. Investors: exclusive off-market wholesale deals nationwide. Not a brokerage."
        keywords="we buy houses detroit, we buy houses michigan, we buy houses phoenix, we buy houses arizona, we buy houses los angeles, we buy houses california, we buy houses sacramento, we buy houses bakersfield, we buy houses tucson, we buy houses memphis, we buy houses cleveland, we buy houses atlanta, we buy houses indianapolis, we buy houses philadelphia, real estate wholesaling, cash home buyers, off-market deals, sell my house fast, assignment of contract, investment properties, BRRRR rentals, turnkey rentals, distressed properties, foreclosure help"
        canonical="https://www.dreamhousesusa.com/"
        jsonLd={homeJsonLd}
        jsonLdId="home-localbusiness-jsonld"
      />
      <Header />
      <main className="pt-16">
        <HeroSection />
        <section id="how-it-works">
          <HowItWorksSection />
        </section>
        <FormsSection />
        <section id="who-we-help">
          <WhoWeHelpSection />
        </section>
        <MarketsSection />
        <TrustSection />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
